export default function stringOptions(team:string) {
  const newOptions = team.split(',');

  const teamOptions = newOptions?.map((opt) => ({ value: opt, label: opt }));

  return teamOptions;
}
